<!-- 由 suu 创建于 2025-09-03 星期三 -->
<template>
  <div class="CoachTeamItem" @click.stop="handleOpenCoach">
    <div class="coach-info">
      <img class="info-img" :src="info.image" alt="" />
      <div class="info-desc">
        <div class="info-desc-name">{{ info.name }}</div>
        <div class="info-desc-shop">{{ info.shop_name }}</div>
        <div class="info-desc-tag">
          <span
            class="tag-item"
            v-for="(item, index) in info.tag"
            :key="index"
            >{{ item }}</span
          >
        </div>
      </div>
    </div>
    <div class="coach-time">
      <div class="time-title"> 已预约次数 </div>
      <div class="time-num">{{ info.num }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoachTeamItem',

  components: {},

  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() {},

  mounted() {},

  destroyed() {},

  methods: {
    // 跳转到教练详情
    handleOpenCoach() {
      // 获取教练信息
      this.$toast.loading('加载中···')
      this.$http
        .get('member/active?a=coachCard', {
          cid: this.info.id
        })
        .then((rs) => {
          // this.$toast.clear()
          if (rs.data.code === 200 && rs.data.data) {
            this.toDetail(rs.data.data)
          } else {
            this.$dialog({ message: `教练信息获取失败：${rs.data.msg}` })
          }
        })
        .catch((err) => {
          this.$dialog({ message: '网络错误' })
          this.$toast.clear()
        })
    },
    /**
     * 自主约课 跳转教练排课详情
     * @param cid 教练ID
     * @param obj 教练信息
     */
    toDetail(obj) {
      let detailData = obj
      let currDay = this._getCurDay()
      // 教练详情默认请求此日期的排课信息
      detailData['coursetime'] = currDay
      if (Object.keys(detailData).length > 0) {
        this.$store.commit('setDetailData', detailData)
        this.$store.commit('setCurrDay', currDay)
        this.$toast.clear()
        this.$router.push({
          path: '/subscribe/detail'
        })
      }
    },
    //  * 获取当日 格式
    _getCurDay() {
      const week = ['日', '一', '二', '三', '四', '五', '六']
      const date = new Date()
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1)[1]
        ? String(date.getMonth() + 1)
        : '0' + String(date.getMonth() + 1)
      const day = String(date.getDate())[1]
        ? String(date.getDate())
        : '0' + String(date.getDate())
      let obj = {
        a_day: year + '-' + month + '-' + day,
        day: date.getMonth() + 1 + '-' + day,
        week: week[date.getDay()]
      }
      return obj
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.CoachTeamItem {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .coach-info {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    display: flex;
    align-items: center;
    .info-img {
      object-fit: cover;
      width: 60px;
      height: 60px;
      border-radius: 50%;
      margin-right: 10px;
    }
    .info-desc {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      .info-desc-name {
        font-size: 15px;
        font-weight: 600;
        color: #050b27;
      }
      .info-desc-shop {
        font-size: 10px;
        color: rgba($color: #050b27, $alpha: 0.5);
        margin-top: 3px;
      }
      .info-desc-tag {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-top: 6px;
        .tag-item {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 9px;
          color: rgba($color: #050b27, $alpha: 0.5);
          background: #f1f1f1;
          border-radius: 2px;
          padding: 1px 3px;
          margin-bottom: 4px;
          &:not(:last-child) {
            margin-right: 4px;
          }
        }
      }
    }
  }
  .coach-time {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 58px;
    height: 60px;
    box-sizing: border-box;
    background: #f9f9f9;
    border-radius: 4px;
    .time-title {
      font-size: 10px;
      color: rgba($color: #050b27, $alpha: 0.5);
    }
    .time-num {
      font-family: DIN;
      font-size: 20px;
      font-weight: 600;
      color: #050b27;
    }
  }
}
</style>
